<template>
    <v-card>
        <v-snackbar
                v-model="snackbar.snackbar"
                color="red"
                :timeout="snackbar.timeout"
                top
        >
         {{ snackbar.text }}
            <v-btn
                    dark
                    text
                    @click="snackbar.snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                Assign Roles
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-alert type="warning" v-if="formAlert">{{formError}}</v-alert>
                    <v-alert type="info" v-if="formSuccessTrue">Role Assigned</v-alert>
                    <v-radio-group v-model="formData.role" :mandatory="false">
                        <p class="pb-2">Admin Type</p>

                        <v-radio v-for="role in roleData" :key="role.id" :label="role.name" :value="role.id"></v-radio>
                    </v-radio-group>
                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" @click="submit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        props: ["userInfoDialog"],
        name: "roleModal",
        watch: {
            updated: {
                handler: function (val) {
                    this.parentResponseData.val = val;
                    this.$emit("formResponse", this.parentResponseData);
                },
                deep: true
            }
        },
        data() {
            return {
                snackbar:{
                    snackbar:false,
                    timeout:3000,
                    text:""
                },
                parentResponseData: {},
                formError: "",
                formSuccess: "",
                formAlert: false,
                formSuccessTrue: false,
                updated: false,
                roleData: [],
                updatedData: {},
                formData: {
                    userID: "",
                    isActive: false,
                    role: ""
                },
                servicesData: {
                    data: {},
                    message: "",
                    color: ""
                }
            };
        },
        mounted() {
            this.formOption();
        },
        methods: {
            dialogueClose() {
                console.log(this.servicesData)
                this.$emit("formResponse", this.servicesData);
            },
            async formOption() {
                console.log(this.userInfoDialog)
                axios.get("User/GetAssignRoles", {
                    params: {UserID: this.userInfoDialog}
                }).then(response => {
                    this.updatedData = response.data;
                  this.formData.role = response.data.roleID;
                    this.formData.isActive = response.data.isActive;
                    this.formData.departmentID = response.data.departmentID;
                    this.formData.branchID = response.data.branchID;
                });
                axios.get("User/GetRolesList")
                    .then(response => {
                        this.roleData = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    });

                console.log(this.updatedData);
            },
            async submit() {
                console.log()
                let formData = {
                    userID: this.userInfoDialog,
                    roleID: this.formData.role,
                    branchID: this.formData.branchID,
                    departmentID: this.formData.departmentID
                }
                await axios.post("user/AssignRoles", formData).then(response => {
                    if(response.data.success){
                        this.editedData = {};
                        this.servicesData.data = response.data
                        this.servicesData.message = "Role Updated Succcessfully"
                        this.servicesData.color = "success"
                        this.dialogueClose()
                    }
                    else{
                        this.snackbar.snackbar = true
                        this.snackbar.text = response.data.errors[0]
                    }
                }).catch(response => {
                    this.servicesData.data = response.data
                    this.servicesData.message = "Error Adding Service, Please Contact Admin"
                    this.servicesData.color = "error"

                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .hr-divider {
        width: 100%;
        max-width: 100%;
        border-width: 1px;
    }
</style>
